import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";

class OpioidUsageStore {
  @observable highest_opioid_usage = [];
  @observable opioid_usage_by_participant = [];
  @observable Highest_Opioid_Physicians = [];
  @observable opioid_timeline = []
  @observable days_supply = [];
  @observable opioid_participant_count = 0;
  @observable opioid_total_spend = 0;
  @observable opioid_count = 0;
  @observable opioid_physician_count = 0;
  @observable url = "/api/v1/insightactions/opioid";


  @computed get tiles() {
    return parseInt(this.opioid_count / 100) > 0 ? parseInt(this.opioid_count / 100) + 1 : 0;
  }
  @computed get tiles2() {
    return parseInt(this.opioid_physician_count / 100) > 0 ? parseInt(this.opioid_physician_count / 100) + 1 : 0;
  }

  @action getOpioidTotalCost = async data => {
    this.opioid_total_spend = 0;
    try {
      let response = await post(
        `${this.url}/getOpioidTotalCost`,
        data
      );

      this.opioid_total_spend = response.data[0].claim_cost;
    } catch (err) {
      console.log(err);
    }
  };

  @action getOpioidTotalCounts = async data => {
    this.opioid_count = 0;
    try {
      let response = await post(
        `${this.url}/getOpioidTotalCounts`,
        data
      );
      if (data.show_by == "Participants") {
        this.opioid_count = response.data.participant_count[0]?.participant_count;
      }
      if (data.show_by == "Drugs") {
        this.opioid_count = response.data.drug_count[0]?.label_count;
      }
    } catch (err) {
      console.log(err);
    }
  };

  @action getHighestOpioidPhysiciansCount = async data => {
    this.opioid_physician_count = 0;
    try {
      let response = await post(
        `${this.url}/getHighestOpioidPhysiciansCount`,
        data
      );
      this.opioid_physician_count = response.data[0]?.total_Count;

    } catch (err) {
      console.log(err);
    }
  };


  @action getOpioidParticipantsCount = async data => {
    this.opioid_participant_count = 0;
    try {
      let response = await post(
        `${this.url}/getOpioidParticipantsCount`,
        data
      );

      this.opioid_participant_count = (new Set(response.data[0].unique_par.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
    } catch (err) {
      console.log(err);
    }
  };

  @action getHighestOpioidPhysicians = async data => {
    try {
      this.Highest_Opioid_Physicians = [];
      let response = await post(
        `${this.url}/getHighestOpioidPhysicians`,
        data
      );
      this.Highest_Opioid_Physicians = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getHighestOpioidUsage = async data => {
    this.highest_opioid_usage = [];
    this.opioid_usage_by_participant = [];
    this.opioid_timeline = [];
    this.days_supply = []
    try {
      let response = await post(
        `${this.url}/getHighestOpioidUsage`,
        data
      );

      this.highest_opioid_usage = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getOpioidUsageByParticipant = async data => {
    this.opioid_usage_by_participant = [];
    this.opioid_timeline = [];
    try {
      let response = await post(
        `${this.url}/getOpioidUsageByParticipant`,
        data
      );

      this.opioid_usage_by_participant = response.data;
    } catch (err) {
      console.log(err);
    }
  };


  @action getOpioidUsageTimeLine = async data => {
    this.opioid_timeline = [];
    try {
      let response = await post(
        `${this.url}/getOpioidUsageTimeLine`,
        data
      );

      this.opioid_timeline = response.data;
    } catch (err) {
      console.log(err);
    }
  };


  @action getDaysSupply = async data => {
    this.days_supply = [];
    try {
      let response = await post(
        `${this.url}/getDaysSupply`,
        data
      );

      this.days_supply = response.data;
    } catch (err) {
      console.log(err);
    }
  };
}

export default OpioidUsageStore;
